import { lazy } from "react";
import Loadable from "app/components/Loadable";

const OptMasterField = Loadable(lazy(() => import("./OptMasterField")));

const optmasterfieldRoute = [{ path: "/opt-masterfield", element: <OptMasterField /> }];
export default optmasterfieldRoute;
